var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var JARVIS_FIELD_TYPES = [
    'action',
    'date',
    'email',
    'multipleChoice',
    'password',
    'select',
    'tel',
    'text',
];
var COMPANY_CONNECT_JOBS = [
    'company_census',
    'company_employments',
    'company_incomes',
];
var READ_JOBS = __spreadArray([
    'employment',
    'identity',
    'income',
    'paystubs',
    'shifts',
    'direct_deposit_allocations',
    'tax_forms'
], COMPANY_CONNECT_JOBS, true);
export var WRITE_JOBS = [
    'direct_deposit_switch',
    'direct_deposit_payment',
    'card_switch',
    'bill_switch',
    'bill_cancellation',
];
export var ALL_JOBS = __spreadArray(__spreadArray([], WRITE_JOBS, true), READ_JOBS, true);
export function hasCompanyConnectJob(jobs) {
    return jobs.some(function (job) { return COMPANY_CONNECT_JOBS.includes(job); });
}
export var SDKS = [
    'android',
    'ios',
    'react native',
    'web',
    'react',
    'standalone-site',
    'flutter',
];
export var DEVICE_PLATFORMS = ['android', 'ios', 'web'];
export var SearchResponseType;
(function (SearchResponseType) {
    SearchResponseType["EMPLOYER"] = "employer";
    SearchResponseType["PLATFORM"] = "platform";
})(SearchResponseType || (SearchResponseType = {}));
